import { invertRadians } from '@Utils/helpers/numericalHelpers';

export function getCoordinatesOfPointOnCircle(
    radius: number,
    bearing: number,
    circleCenter?: { x: number; y: number }
): { x: number; y: number } {
    // need to invert the y axis -> 0 is at the top of the render not the bottom
    const invertedBearing = invertRadians(bearing);

    return {
        x: circleCenter.x + radius * Math.sin(bearing),
        y: circleCenter.y + radius * Math.cos(invertedBearing),
    };
}

export function degreesToRadians(degrees: number): number {
    return (degrees * Math.PI) / 180;
}
